// extracted by mini-css-extract-plugin
module.exports = {"modal":"reject-modal_modal__213-Q","checkbox":"reject-modal_checkbox__2VW6Q","typing":"reject-modal_typing__3H6HJ"};